module.exports = __webpack_public_path__ + "img/dashboard.bf3a470a.png";